import { apiSlice } from 'store/slices/api/api-slice';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        cardActive: builder.mutation({
            query: (cardId: string) => ({
                url: `/card/activate/` + cardId,
                method: 'PATCH',
                header: {},
            }),
        }),
    }),
});

export const { useCardActiveMutation } = importTradeDataApiSlice;
